import React from 'react';
import classnames from 'classnames';

class TabbarButton extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'TabbarButton';
  }

  render() {
    return (
      <a href="javascript:;" onClick={ this.props.onClick } {...this.props.attributes}
        className={ classnames('tabbar-btn col-33 tabbar-btn-danger', this.props.className) }
        dangerouslySetInnerHTML={{ __html: this.props.content }}>
      </a>
    );
  }
}

TabbarButton.defaultProps = {
  className: null,
  onClick: () => {},
  attributes: {},
  content: 'click here'
};

TabbarButton.propTypes = {
  className: React.PropTypes.string,
  attributes: React.PropTypes.object,
  onClick: React.PropTypes.func,
  content: React.PropTypes.string
};

export default TabbarButton;



/** WEBPACK FOOTER **
 ** ./src/javascript/react-tabbar-button.jsx
 **/